import { isNavItemVisible } from "./featureVisibility";
import { NAV_PAGE_LABELS as SHARED_NAV_PAGE_LABELS } from "./navConfig";
import { canUseRemoteAttendance } from "./workModeHelpers";

/** فتح القائمة الجانبية الكاملة */
export const MENU_ITEM_ID = "__menu__";

export const NAV_PAGE_LABELS = SHARED_NAV_PAGE_LABELS;

/**
 * عناصر الشريط السفلي لكل دور — أهم 4 إجراءات + «المزيد».
 * Labels match NAV_PAGE_LABELS where the bar has room; shorter aliases
 * stay only when the full title overflows a 5-slot tab.
 * badgeKey يطابق مفاتيح buildActionBadges في pendingActionBadges.js
 */
export const MOBILE_BOTTOM_NAV_BY_ROLE = {
  employee: [
    { id: "home", label: NAV_PAGE_LABELS.home, icon: "LayoutGrid" },
    { id: "leave", label: NAV_PAGE_LABELS.leave, icon: "FileText" },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    {
      id: "attendance",
      label: "حضور",
      icon: "Clock",
      requiresRemoteAttendance: true,
    },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  manager: [
    { id: "home", label: NAV_PAGE_LABELS.home, icon: "LayoutGrid" },
    {
      id: "approvals",
      label: "موافقات",
      icon: "ShieldCheck",
      badgeKey: "approvals",
    },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "team", label: NAV_PAGE_LABELS.team, icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  "department-manager": [
    { id: "dashboard", label: NAV_PAGE_LABELS.dashboard, icon: "LayoutGrid" },
    {
      id: "approvals",
      label: "موافقات",
      icon: "ShieldCheck",
      badgeKey: "approvals",
    },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "departments", label: "الفروع", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  hr: [
    { id: "dashboard", label: NAV_PAGE_LABELS.dashboard, icon: "LayoutGrid" },
    {
      id: "team-approvals",
      label: "موافقات",
      icon: "ShieldCheck",
      badgeKey: "team-approvals",
    },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "employees", label: "موظفين", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  "hr-staff": [
    { id: "dashboard", label: NAV_PAGE_LABELS.dashboard, icon: "LayoutGrid" },
    {
      id: "team-approvals",
      label: "موافقات",
      icon: "ShieldCheck",
      badgeKey: "team-approvals",
    },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "employees", label: "موظفين", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  gm: [
    { id: "dashboard", label: NAV_PAGE_LABELS.dashboard, icon: "LayoutGrid" },
    {
      id: "approvals",
      label: "موافقات",
      icon: "ShieldCheck",
      badgeKey: "approvals",
    },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "employees", label: "موظفين", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  owner: [
    { id: "dashboard", label: NAV_PAGE_LABELS.dashboard, icon: "LayoutGrid" },
    { id: "requests", label: "الطلبات", icon: "FileText" },
    {
      id: "notifications",
      label: "إشعارات",
      icon: "Bell",
      badgeKey: "notifications",
    },
    { id: "employees", label: "موظفين", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
  admin: [
    { id: "accounts", label: "حسابات", icon: "ShieldCheck" },
    { id: "employees", label: "موظفين", icon: "Users" },
    { id: "departments", label: "فروع", icon: "Users" },
    { id: MENU_ITEM_ID, label: "المزيد", icon: "Menu" },
  ],
};

export function buildMobileBottomNavItems({
  userRole,
  workMode,
  featureFlags,
}) {
  const template =
    MOBILE_BOTTOM_NAV_BY_ROLE[userRole] ||
    MOBILE_BOTTOM_NAV_BY_ROLE.employee;
  const showRemoteAttendance = canUseRemoteAttendance(workMode);

  return template.filter((item) => {
    if (item.id === MENU_ITEM_ID) return true;
    if (item.requiresRemoteAttendance && !showRemoteAttendance) return false;
    return isNavItemVisible(featureFlags, item.id);
  });
}

export { getPageTitle } from "./navConfig";

/** شارة «المزيد» = إجراءات معلّقة في صفحات ليست في الشريط السفلي */
export function getMenuOverflowBadgeCount(bottomNavItems, badges = {}) {
  const bottomKeys = new Set(
    bottomNavItems
      .filter((item) => item.id !== MENU_ITEM_ID && item.badgeKey)
      .map((item) => item.badgeKey),
  );
  let total = 0;
  Object.entries(badges).forEach(([key, count]) => {
    if (bottomKeys.has(key)) return;
    if (count > 0) total += count;
  });
  return total;
}

export function isBottomNavPage(activeId, bottomNavItems) {
  return bottomNavItems.some(
    (item) => item.id !== MENU_ITEM_ID && item.id === activeId,
  );
}
